import axios from 'axios';
import { FolderSelectionType } from './foldersDropdown.types';

export async function listFoldersForDecision(
  docId: string,
): Promise<FolderSelectionType[]> {
  return (
    await axios.get('/folders/listFoldersForDecision', {
      params: {
        docId,
      },
    })
  ).data;
}
